import { action } from "@ember/object"
import Component from "@glimmer/component"

interface Options {}

interface Sig {
  Args: {
    options: Options
    accept: (editResult: "accept" | "reject") => void
    decline: () => void
  }
}

export default class ConfirmExitAi extends Component<Sig> {
  @action
  onKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.stopPropagation()
      this.args.accept("accept")
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Dialogs::ConfirmExitAi": ConfirmExitAi
  }
}
